<template>
  <v-row class="pa-0">
    <v-col v-if="params.context.parentComponent.tab != 4">
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-icon   
            v-if="
              params &&
              params.context &&
              params.context.parentComponent &&
              params.context.parentComponent.permissions &&
              params.context.parentComponent.permissions.add &&
              params.context.parentComponent.tab == 0
            "
            color="success"
            v-on="on"
            v-bind="attrs"
            @click="updateStatus(params.data, 'Accepted')"
            class="ml-1 mr-2"
          >
            mdi-check
          </v-icon>
        </template>
        <span>Accept</span>
      </v-tooltip>
    

   

      <v-tooltip top>
        <template #activator="{ on, attrs }">
          <v-icon
            class="ml-2 mr-1"
            color="primary"
            v-on="on"
            v-bind="attrs"
            @click="viewLogs"
          >
            mdi-information
          </v-icon>
        </template>
        <span>Debit Note Logs</span>
      </v-tooltip>
    
    </v-col>
  </v-row>
</template>

<script>
export default {
  methods: {
    
    updateStatus(data, status) {
      this.params.context.parentComponent.openRemarksForm(data, status);
    },
    
    viewLogs() {
      this.params.context.parentComponent.viewDebitNoteLogs(
        this.params.data.id
      );
    },
  },
};
</script>

<style></style>
